module.exports = __webpack_public_path__ + "static/media/android-phone-slash.298d5750.svg";